module.exports = __webpack_public_path__ + "img/util-date.f0f07797.svg";